import React, { useCallback, useContext, useRef } from "react";
import paper from "../../assets/paper.png";
import pencil from "../../assets/pencil.png";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import "./SubscriptionDetails.css";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import SubOverview from "./SubOverview";
import { subscriptionService } from "../../services/subscription.service";
import { SetSubScriptionEdit } from "../../store/subscriptionAtom";
import LogicContext from "../../Context/LogicContext";
import SubDetailsScroll from "./SubDetailsScroll";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { GetSubMData, SetSubMData } from "../../store/subscriptionAtom";
import SubscriptionInvoiceHistory from "./SubscriptionInvoiceHistory";
import SubscriptionSalesOrder from "./SubsciptionSalesOrder";
import { Tooltip } from "@mui/material";
import { FaPlus } from "react-icons/fa";
import { MdEdit } from "react-icons/md";

function SubscriptionDetailsPage() {
  const [subDetails, setSubDetails] = useState({});
  const [invoiceList, setSubInvoice] = useState([]);
  const [salesOrderList, setSalesOrder] = useState([]);
  const logicContext = useContext(LogicContext);
  const myPromiseModal = createModal(GeneralModal);
  const setSubscriptionEdit = SetSubScriptionEdit();
  const [selectedList, setSelectedList] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [tabValue, setTabValue] = useState("1");
  const getSubData = GetSubMData();
  const setSubData = SetSubMData();
  const { sub_id } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    document.title = "Subscription Details";
    getSubDetails(sub_id);
    return () => {
      isMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sub_id]);

  const getSubDetails = async (id) => {
    subscriptionService
      .getSubscription(id)
      .then((res) => {
        const serverData = res.data;
        if (serverData?.subscription_info) {
          setSubDetails(serverData?.subscription_info[0]);
        }
        if (serverData?.invoice_info?.length) {
          setSubInvoice(serverData?.invoice_info);
        } else {
          setSubInvoice([]);
        }
        if (serverData?.salesorder_info?.length) {
          setSalesOrder(serverData?.salesorder_info);
        } else {
          setSalesOrder([]);
        }
        if (serverData?.subscription_item_info) {
          setItemList(serverData?.subscription_item_info);
        }
      })
      .catch((err) => {
        console.log("Err ", err);
      });
  };

  useEffect(() => {
    isMounted.current = true;
    if (getSubData.subscription_info?.length < 1) {
      subscriptionService.getSubList().then((res) => {
        if (res?.data && isMounted.current) {
          setSubData(res?.data);
        }
      });
    }
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  function viewItemDetails(id) {
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`
    );
    getSubDetails(id);
  }

  const editSubscription = async () => {
    await myPromiseModal({
      title: "Confirmation",
      body: "Do you want to modify this subscription?",
      showInput: false,
      placeHolder: "",
    }).then((res) => {
      if (res.decision === true) {
        setSubscriptionEdit({ details: subDetails, itemList: itemList });
        navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
      }
    });
  };

  const addNewSubscription = async () => {
    const response = await myPromiseModal({
      title: "Add subscription",
      body: "Do you want to add subscription?",
      showInput: false,
      placeHolder: "",
    });
    if (response.decision === true) {
      navigate(
        `/${currModuleId}/${currModuleName}/subscriptions/add-new?Customer_Id=${
          subDetails?.customer_id
        }&Customer_Full_Name=${subDetails?.customer_full_name}`
      );
    }
  };

  async function onSingleAction(Ref_no, option) {
    let title = "Confirmation";
    let body = "Please confirm your action!";
    if (option === 10) {
      title = "Confirm delete";
      body =
        "Please ensure you know what you are doing. Deleted records cannot be recovered.";
    }
    await myPromiseModal({
      title,
      body,
      showInput: false,
      placeHolder: "",
    }).then((response) => {
      if (response.decision === true) {
        subscriptionService
          .submitBulkAction({
            option: option,
            xml_string_subs: `<root><a> <refno>${Ref_no} </refno> </a> </root>`,
          })
          .then((res) => {
            const { message_text, message_id } = res?.data[0];
            if (res.data !== undefined && message_id == 1) {
              if (option === 10) {
                loadItemsFromServer(option);
              } else {
                getSubDetails(Ref_no);
              }
              logicContext.showToast(message_text, "success");
            } else {
              logicContext.showToast("Error processing request!", "error");
            }
          });
      }
    });

    function loadItemsFromServer(option) {
      subscriptionService.getSubList().then((res) => {
        if (res?.data !== undefined) {
          setSubData(res?.data);
          if (option == 10) {
            navigate(-1);
          }
        }
      });
    }
  }

  function onSelection(list) {
    let tempList = list?.filter((item) => item.checked === true);
    setSelectedList(tempList);
  }

  function updateBillingDate(newDate) {
    if (newDate) {
      let body = {
        option: 11,
        Next_Billed_Date: newDate,
        Subscription_Ref_No: sub_id,
      };
      subscriptionService.updateSubBillingDate(body).then((response) => {
        const { message_text, message_id } = response.data[0];
        if (message_id === 1) {
          logicContext.showToast(message_text, "success");
          getSubDetails(sub_id);
        }
      });
    }
  }

  const viewCustomer = (id) => {
    const customerRoute = `/${currModuleId}/${currModuleName}/customers/customer-details/${id}`;
    window.open(customerRoute, "_blank");
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
          <h1 className="text-xl sm:text-2xl font-bold text-gray-900">Subscription Details</h1>
          <div className="flex items-center space-x-3">
            <Tooltip title="New Subscription">
              <button
                onClick={addNewSubscription}
                className="flex items-center px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition text-sm font-medium"
              >
                <FaPlus className="h-4 w-4 mr-2" />
                New Subscription
              </button>
            </Tooltip>
            <Tooltip title="Edit Subscription">
              <button
                onClick={editSubscription}
                className="flex items-center px-3 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition text-sm font-medium"
              >
                <MdEdit className="h-4 w-4 mr-2" />
                Edit Subscription
              </button>
            </Tooltip>
            <div className="relative group">
              <button className="px-3 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition text-sm font-medium">
                More Actions
              </button>
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg hidden group-hover:block z-10">
                <button
                  onClick={() => onSingleAction(sub_id, 8)}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition"
                >
                  Pause Subscription
                </button>
                <button
                  onClick={() => onSingleAction(sub_id, 9)}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition"
                >
                  Resume Subscription
                </button>
                <button
                  onClick={() => onSingleAction(sub_id, 4)}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel Subscription
                </button>
                <button
                  onClick={() => onSingleAction(sub_id, 10)}
                  className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition"
                >
                  Delete Subscription
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex flex-col lg:flex-row gap-6">
          {/* Sidebar */}
          <div className="w-full lg:w-64 flex-shrink-0">
            <SubDetailsScroll
              viewItemDetails={viewItemDetails}
              subDetails={subDetails}
              onSelection={onSelection}
            />
          </div>

          {/* Tabs Section */}
          <div className="flex-1">
            <Box sx={{ width: "100%" }}>
              <TabContext value={tabValue}>
                <Box className="bg-white rounded-t-md shadow-sm">
                  <TabList
                    onChange={handleTabChange}
                    aria-label="Subscription Tabs"
                    TabIndicatorProps={{
                      sx: {
                        backgroundColor: "#3B82F6",
                        height: 3,
                        borderRadius: 2,
                      },
                    }}
                    sx={{
                      ".MuiTab-root": {
                        textTransform: "none",
                        fontWeight: 500,
                        fontSize: "0.875rem",
                        padding: "0.75rem 1.5rem",
                        color: "#6B7280",
                        "&.Mui-selected": {
                          color: "#1F2937",
                          backgroundColor: "#F9FAFB",
                        },
                        "&:hover": {
                          backgroundColor: "#F3F4F6",
                        },
                        "&:focus": {
                          outline: "none",
                          boxShadow: "none",
                        },
                      },
                    }}
                  >
                    <Tab label="Overview" value="1" />
                    <Tab label="Invoice History" value="2" />
                    <Tab label="Sales Orders" value="3" />
                    <Tab label="Recent Activities" value="4" />
                  </TabList>
                </Box>
                <div className="bg-white rounded-b-md shadow-sm p-4 sm:p-6">
                  <TabPanel value="1" className="p-0">
                    <SubOverview
                      viewCustomer={viewCustomer}
                      subDetails={subDetails}
                      itemList={itemList}
                      updateBillingDate={updateBillingDate}
                    />
                  </TabPanel>
                  <TabPanel value="2" className="p-0">
                    <SubscriptionInvoiceHistory invoiceList={invoiceList} />
                  </TabPanel>
                  <TabPanel value="3" className="p-0">
                    <SubscriptionSalesOrder salesOrderList={salesOrderList} />
                  </TabPanel>
                  <TabPanel value="4" className="p-0">
                    <div className="text-gray-600 text-sm">
                      Recent activities content goes here
                    </div>
                  </TabPanel>
                </div>
              </TabContext>
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionDetailsPage;